module.exports = __webpack_public_path__ + "static/media/mpl.57b96036.png";